module.exports = __webpack_public_path__ + "static/img/pinpai-18.c84a7716.png";